import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BsStopwatch } from 'react-icons/bs';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import Confetti from 'react-confetti';
import axios from 'axios';

const Terminer = () => {
    useAuth(); // Vérifier l'authentification
    const navigate = useNavigate();
    const user_id = localStorage.getItem('user_id');
    const [qcms, setQcms] = useState([]);
    const [simulation, setSimulation] = useState([]);
    const [showConfetti, setShowConfetti] = useState(false);
    const [showInfo, setShowInfo] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // Changé à true par défaut

    const location = useLocation();
    const simulation_id = location.state?.simulation_id; // Vérifiez que simulation_id existe
    console.log(simulation_id)

    // Dimensions de la fenêtre pour le composant Confetti
    const [windowDimensions, setWindowDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        if (simulation.pourcentage > 50) {
            setShowConfetti(true); // Affiche les confettis
            const timer = setTimeout(() => setShowConfetti(false), 5000); // Arrête après 5s
            return () => clearTimeout(timer); // Nettoie le timeout si le composant est démonté
        }
    }, [simulation.pourcentage]);


    useEffect(() => {
        // Mettre à jour les dimensions de la fenêtre si elle est redimensionnée
        const handleResize = () => {
            setWindowDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Terminer";
        }
    }, [user_id]);

    useEffect(() => {
        if (simulation_id) { // Vérifiez que simulation_id existe avant de lancer la requête
            const fetchSimulationsQcm = async () => {
                setIsLoading(true);
                try {
                    const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-qcms/${user_id}/${simulation_id}/`);
                    if (response.ok) {
                        const data = await response.json();
                        const qcmsWithResult = data.qcms.filter(qcm => qcm.resultat); // Filtre pour garder seulement les QCMs avec un 'resultat'
                        setQcms(qcmsWithResult);
                    } else {
                        console.error('Erreur lors de la récupération des simulations');
                    }
                } catch (error) {
                    console.error('Erreur réseau:', error);
                } finally {
                    setIsLoading(false);
                }
            };
            fetchSimulationsQcm();
        }
    }, [user_id, simulation_id]);

    useEffect(() => {
        if (simulation_id) { // Vérifiez que simulation_id existe avant de lancer la requête
            const fetchSimulations = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-simulation/${user_id}/${simulation_id}/`);
                    if (response.ok) {
                        const data = await response.json();
                        setSimulation(data);
                    } else {
                        console.error('Erreur lors de la récupération des simulations');
                    }
                } catch (error) {
                    console.error('Erreur réseau:', error);
                }
            };
            fetchSimulations();
        }
    }, [user_id, simulation_id]);

    const isSuccessful = simulation.pourcentage > 50; // Vérifie si le pourcentage dépasse 50


    const [currentPage, setCurrentPage] = useState(1);
    const itemsParPage = 5;


    const totalPages = Math.ceil(qcms.length / itemsParPage);


    const debutIndex = (currentPage - 1) * itemsParPage;
    const finIndex = debutIndex + itemsParPage;
    const currentQcms = qcms.slice(debutIndex, finIndex);


    const pageSuivante = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const pagePrecedente = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    // Loader component
    const Loader = () => (
        <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                <span className="sr-only">Chargement...</span>
            </div>
            <p className="mt-3">Chargement des résultats...</p>
        </div>
    );

    if (!accesGroupe.includes("Simulation")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            {isSuccessful && showConfetti && (
                <Confetti
                    width={windowDimensions.width}
                    height={windowDimensions.height}
                />
            )}
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className='row align-items-end'>
                                <h2>
                                    <BsStopwatch size={25} className='mr-2' />Simulateur
                                </h2>
                                <span
                                    className="ml-3 toggle-icon"
                                    style={{ cursor: 'pointer', marginBottom: '10px' }}
                                    onClick={() => setShowInfo(!showInfo)}
                                >
                                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                            </div>

                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                                <small>
                                    Résultat et correction de la simulation. Les explications et les éventuelles références au Guide PMBOK aident à mieux comprendre la logique des questions. <br /><b>Légende des icônes : </b>
                                    <i className="fa fa-thumbs-o-up ivt-align-menu"></i> indique la bonne réponse,
                                    <i className="fa fa-thumbs-o-down ivt-align-menu"></i> indique la mauvaise réponse.
                                </small>
                            </div>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Historique-complet`}>Simulateur</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {simulation_id}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox">
                                    <div className="ibox-title pr-3">
                                        <h5>Résultats de la simulation</h5>
                                        {isLoading ? (
                                            <Loader />
                                        ) : (
                                            <div className="table-responsive">
                                                <table className="table table-striped table-hover">
                                                    <tbody>
                                                        <tr>
                                                            <td>Simulation : </td>
                                                            <td>{simulation.id}</td>
                                                            <td>Domaine de connaissance : </td>
                                                            <td>{simulation.domaine_titre}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Date et heure : </td>
                                                            <td>{simulation.date}</td>
                                                            <td>Groupe de processus : </td>
                                                            <td>{simulation.processus_titre}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Questions demandées : </td>
                                                            <td>{simulation.qcmNumber}</td>
                                                            <td>Uniquement QCM non traités : </td>
                                                            <td>{simulation.nonTraite ? 'Oui' : 'Non'}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Questions traitées : </td>
                                                            <td>{qcms.length}</td>
                                                            <td>Agile/adaptation : </td>
                                                            <td>{simulation.agile ? 'Oui' : 'Non'}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Bonnes réponses : </td>
                                                            <td>
                                                                <div className="progress m-t-xs full">
                                                                    <div
                                                                        className="progress-bar progress-bar-success"
                                                                        role="progressbar"
                                                                        aria-valuemin="0"
                                                                        aria-valuemax="100"
                                                                        aria-valuenow={simulation.pourcentage}
                                                                        style={{ width: `${simulation.pourcentage}%` }}
                                                                    >
                                                                        <span className={simulation.pourcentage === 0 && 'text-dark'}>
                                                                            {simulation.pourcentage}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>Niveau : </td>
                                                            <td>{simulation.niveau}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                    <div className="ibox-content text-dark">
                                        {isLoading ? (
                                            <Loader />
                                        ) : (
                                            <>
                                                {currentQcms.length > 0 ? (
                                                    currentQcms.map((qcm) => (
                                                        <div key={qcm.id} style={{ borderBottom: '1px solid #ccc', paddingBottom: '15px', marginBottom: '15px' }}>
                                                            <input type="hidden" name="qcmidhidden" id="qcmidhidden" value={qcm.id} />
                                                            <div>
                                                                <span># {qcm.ref} - </span>
                                                                <span
                                                                    id="question"
                                                                    style={{ fontSize: '13px' }}
                                                                    dangerouslySetInnerHTML={{ __html: qcm.question }}
                                                                ></span>
                                                            </div>
                                                            <div style={{ margin: '10px 10px' }}>
                                                                {(() => {
                                                                    // Créer un tableau des options valides avec leurs lettres
                                                                    const validOptions = Object.keys(qcm)
                                                                        .filter((key) => key.startsWith('option') && qcm[key] && qcm[key] !== 'non défini' && qcm[key] !== 'vide')
                                                                        .map((key, index) => ({
                                                                            letter: String.fromCharCode(65 + index), // A, B, C, ... basé sur les options valides
                                                                            text: qcm[key],
                                                                            key: key
                                                                        }));

                                                                    return validOptions.map((option) => {
                                                                        const isCorrectAnswer = Array.isArray(qcm.reponse) && qcm.reponse.includes(option.letter);
                                                                        const isUserAnswer = Array.isArray(qcm.resultat) && qcm.resultat.includes(option.letter);

                                                                        return (
                                                                            <div
                                                                                key={option.key}
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    marginBottom: '10px',
                                                                                    fontSize: '12px',
                                                                                }}
                                                                            >
                                                                                <span style={{ marginRight: '2px' }}>
                                                                                    {option.letter} - {option.text}
                                                                                </span>

                                                                                {/* Gestion des icônes */}
                                                                                {isCorrectAnswer && isUserAnswer ? (
                                                                                    // Réponse correcte sélectionnée
                                                                                    <i
                                                                                        className="fa fa-thumbs-o-up fa-2x"
                                                                                        style={{ color: 'green', marginLeft: '5px' }}
                                                                                        title="Correct Answer (Selected)"
                                                                                    ></i>
                                                                                ) : isUserAnswer && !isCorrectAnswer ? (
                                                                                    // Réponse sélectionnée mais incorrecte
                                                                                    <i
                                                                                        className="fa fa-thumbs-o-down fa-2x"
                                                                                        style={{ color: 'red', marginLeft: '5px' }}
                                                                                        title="Incorrect Answer (Selected)"
                                                                                    ></i>
                                                                                ) : isCorrectAnswer ? (
                                                                                    // Réponse correcte non sélectionnée
                                                                                    <i
                                                                                        className="fa fa-thumbs-o-up fa-2x"
                                                                                        style={{ color: 'green', marginLeft: '5px' }}
                                                                                        title="Correct Answer"
                                                                                    ></i>
                                                                                ) : null}
                                                                            </div>
                                                                        );
                                                                    });
                                                                })()}
                                                                <div style={{ marginTop: '10px', fontStyle: 'italic', color: 'blue' }}>
                                                                    <p>
                                                                        Bonnes réponses : {qcm.reponse.join(', ')}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            {qcm.explication && qcm.explication != 'non défini' && (
                                                                <div style={{ color: 'green' }}>
                                                                    <span>Explication : </span>
                                                                    <span
                                                                        id="explication"
                                                                        style={{
                                                                            fontSize: '12px',
                                                                            color: 'green',
                                                                            marginTop: '10px',
                                                                        }}
                                                                        dangerouslySetInnerHTML={{ __html: qcm.explication }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))
                                                ) : (
                                                    <p>Aucun QCM avec résultat trouvé pour cette simulation.</p>
                                                )}


                                                {/* Pagination controls */}
                                                {totalPages > 1 && (
                                                    <div className="d-flex align-items-center mt-4 mb-4">
                                                        {currentPage > 1 && (
                                                            <Button className="btn btn-success me-2" onClick={pagePrecedente}>
                                                                <FaArrowAltCircleLeft />
                                                            </Button>
                                                        )}

                                                        <span className="flex-grow-1 text-center">Page {currentPage} sur {totalPages}</span>

                                                        {currentPage < totalPages && (
                                                            <Button className="btn btn-success ms-2" onClick={pageSuivante}>
                                                                <FaArrowAltCircleRight />
                                                            </Button>
                                                        )}
                                                    </div>
                                                )}


                                                <div className="d-flex justify-content-end mt-4">
                                                    <Button
                                                        className='btn btn-success d-flex align-items-center justify-between'
                                                        onClick={() => navigate('/Historique-complet')}
                                                    >
                                                        <FaArrowAltCircleLeft className='mr-1' />
                                                        <span className="d-none d-sm-inline">
                                                            Retour à la liste des simulations
                                                        </span>
                                                    </Button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Terminer;